import { render } from "./Button-nav.vue?vue&type=template&id=4381699f&scoped=true"
const script = {}

import "./Button-nav.vue?vue&type=style&index=0&id=4381699f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4381699f"]])

export default __exports__